<div class="text-center current-edit-mode-wrapper">
    <div [class.draw]="applicationStateService.pageEditMode.type === 'DRAW'"
         [class.linking]="applicationStateService.pageEditMode.type === 'WHITEBOARD_LINKING' || applicationStateService.pageEditMode.type === 'HOMEWORK_EDIT'|| applicationStateService.pageEditMode.type === 'TEST_EDIT'"
         [class.note]="applicationStateService.pageEditMode.type === 'RECT'"
         [class.selection]="applicationStateService.pageEditMode.type === 'SELECTION' || applicationStateService.pageEditMode.type === 'COPY'"
         class="current-edit-mode">
        <span>Modus: <strong>{{ applicationStateService.pageEditMode | pageEditModeName }}</strong></span>
        <button (click)="dismissMode()" title="Schließen"><i class="fas fa-times"></i></button>
    </div>
</div>
